<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "TestCase"
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/core/case/TestCase.vue